<template>
  <div class="LocalInfoHome notranslate">

    <div class="gridHeader" @click="go('recommend')">
      <div class="headerTitle">{{getTitle}}</div>
      <div>+ {{dataLength}} Results</div>
    </div>

    <div class="gridLayOut">
      <div class="grid">
        <template v-for="(item, idx) in repItem">
          <div :key="idx+'lg'" @click="go(item.siteType)"
          class="grid__item" :class="{'grid__item--lg': idx%2 === 0, 'grid__item--sm color_A': idx%2 === 1}" :style="generate(item, idx%2 === 0? true:false)">
            <div class="outer" v-if="idx%2 === 0? false:true">
              <div class="inner">
                <div class="typeIcon"><img :src="require(`@/assets/img/localType/${item.siteType}.png`)"></div>
                <div>{{typeToUpper(item.siteType)}}</div>
                <div class="count">+ {{count(item.siteType)}}</div>
              </div>
            </div>
          </div>
          <div :key="idx+'sm'" @click="go(item.siteType)"
          class="grid__item" :class="{'grid__item--sm color_B': idx%2 === 0, 'grid__item--lg': idx%2 === 1}" :style="generate(item, idx%2 === 0? false:true)">
            <div class="outer" v-if="idx%2 === 0? true:false">
              <div class="inner">
                <div class="typeIcon"><img :src="require(`@/assets/img/localType/${item.siteType}.png`)"></div>
                <div>{{typeToUpper(item.siteType)}}</div>
                <div class="count">+ {{count(item.siteType)}}</div>
              </div>
            </div>
          </div>
        </template>
        <div class="grid__item--footer color_B" @click="go('recommend')">
          <div class="outer">
            <div class="count">+ Show More Info</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LocalInfoHome',
  data () {
    return {
      dataLength: null
    }
  },
  props: [
    'all',
    'typeList',
    'locale'
  ],
  computed: {
    ...mapGetters({
      getTitle: 'common/getTitle'
    }),
    repItem () {
      this.dataLength = this.all.length
      let filter = ['restaurant', 'cafe', 'park', 'tourist_attraction']
      let item = this.all.reduce((accum, curr) => {
        if (filter.includes(curr.siteType) && !!curr.sitePhotos) {
          if (accum.findIndex(x => x.siteType === curr.siteType) === -1) {
            accum.push(curr)
          }
        }
        return accum
      }, [])

      for (let i = 0; i < filter.length; i++) {
        let itemIdx
        let tmp = item.reduce((accum, curr, idx) => {
          if (curr.siteType === filter[i]) {
            accum = curr
            itemIdx = idx
          }
          return accum
        }, null)
        if (tmp) {
          item.splice(itemIdx, 1)
          item.unshift(tmp)
        }
      }

      return item
    }
  },
  methods: {
    sitePhotos (img) {
      return `https://google-map-photos.s3.ap-northeast-2.amazonaws.com/${img}`
    },
    generate (item, state) {
      if (state) return { 'background-image': 'url(' + this.sitePhotos(item.sitePhotos[0]) + ')' }
    },
    go (type) {
      let goal = type
      if (!this.typeList.includes(type)) goal = this.typeList[0]
      this.$router.replace({ name: 'filteredLocalinfo', params: { type: goal } })
    },
    typeToUpper (type) {
      let item = this.locale[`localinfo_${type}`]
      return item.toUpperCase()
    },
    count (type) {
      let count = this.all.reduce((accum, curr) => {
        if (curr.siteType === type) accum += 1
        return accum
      }, 0)

      return count
    }
  }
}
</script>

<style lang="scss" scoped>
  .gridHeader{
    background-color: #ec6578;
    margin: 0 0 0.3rem 0;
    padding: 1rem 0 1rem 0;
    text-align: center;
    color: #FFFC54;
    font-size: 0.9rem;
  }

  @media (min-width: 648px) {
    .gridHeader{
      margin: 0 calc(50% - 320px) 0.3rem calc(50% - 320px);
    }
  }

  .headerTitle{
    color:white;
  }
  .gridLayOut{
    padding: 0px calc(50% - 320px) 20px calc(50% - 320px);
  }
  .grid {
    display:grid;
    grid-template-columns: repeat(12,1fr);
    grid-gap: 4px;
  }

  .grid__item {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    object-fit: cover;
    overflow: visible;
  }
  .grid .grid__item::before {
    content: "";
    padding-bottom: 100%;
    display: inline-block;
    vertical-align: top;
  }
  .grid__item--lg {
    grid-column: span 7;
    grid-row: span 12;
    position: relative;
  }
  .grid__item--sm {
    text-align: center;
    grid-column: span 5;
    grid-row: span 12;
    position: relative;
  }
  .grid__item--footer {
    height: 60px;
    text-align: center;
    grid-column: span 12;
    grid-row: span 12;
    position: relative;
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
  }
  .outer {
    position: absolute;
    bottom: 35%;
    left: 5px;
    right: 5px;
  }
  .inner{
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
  }
  .typeIcon{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 2.3rem;
  }
  .count{
    font-size: 0.9rem;
    font-weight: 400;
  }

  .color_A{
    background-color: #c54d57;
  }

  .color_B{
    background-color: #ec6578;
  }
  </style>
